import { RenewalType } from './renewalTableTileTypes';

export const renewalTypeFromString = (c?: string): RenewalType => {
    const renewalKey = Object.keys(RenewalType).find(key => RenewalType[key] === c);

    return renewalKey ? RenewalType[renewalKey] : RenewalType.RECOMMENDED;
};
